import { HTTP_INTERCEPTORS, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../../appServices/AuthService/auth.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.isLoggedIn()) {
      // if (!this.auth.isTokenExpired()) {
        if (req.headers.get('enctype') == 'multipart/form-data') { // this section is currently idle
          req = req.clone({
            setHeaders: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': 'Origin, X-Auth-Token',
              'Access-Control-Allow-Methods': 'GET, POST, PUT,PATCH, DELETE, OPTIONS',
              'Accept': ['*/*'],
              'Authorization': `Bearer ${this.auth.getTokken()}`,
              "Permissions-Policy": "camera=*,geolocation=*,microphone=*,autoplay=*,fullscreen=*,picture-in-picture=*,sync-xhr=*,encrypted-=*,oversized-images=*",
              "Strict-Transport-Security": "max-age=31536000; includeSubdomains;preload",
              "X-Content-Type-Options": "nosniff",
              "X-Xss-Protection": "1; mode=block",
              "Content-Security-Policy": "default-src 'self';frame-src 'self' 'unsafe-inline' 'unsafe-eval' http://*/elm https://*/elm;script-src 'self' 'unsafe-inline' 'unsafe-eval'  http://*/elm https://*/elm;style-src 'self' 'unsafe-inline' 'unsafe-eval' http://*/elm https://*/elm"
            },
          });
        }
        else {
          req = req.clone({
            setHeaders: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
              'Access-Control-Allow-Methods': 'GET, POST, PUT,PATCH, DELETE, OPTIONS',
              'Content-Type': 'application/json; charset=utf-8',
              //'Access-Control-Max-Age': '86400',
              'Accept': ['application/json', 'text/plain', '*/*'],
              'Authorization': `Bearer ${this.auth.getTokken()}`,
              "Permissions-Policy": "camera=*,geolocation=*,microphone=*,autoplay=*,fullscreen=*,picture-in-picture=*,sync-xhr=*,encrypted-media=*,oversized-images=*",
              "Strict-Transport-Security": "max-age=31536000; includeSubdomains;preload",
              "X-Content-Type-Options": "nosniff",
              "X-Xss-Protection": "1; mode=block",
              "Content-Security-Policy": "default-src 'self';frame-src 'self' 'unsafe-inline' 'unsafe-eval' http://*/elm https://*/elm;script-src 'self' 'unsafe-inline' 'unsafe-eval'  http://*/elm https://*/elm;style-src 'self' 'unsafe-inline' 'unsafe-eval' http://*/elm https://*/elm"

            },
          });
        }
      // } else {
        // localStorage.removeItem("isLogIn");
        // this.auth.refreshToken('auth');
        // req = req.clone({
        //   setHeaders: {
        //     'Access-Control-Allow-Origin': '*',
        //     'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
        //     'Access-Control-Allow-Methods': 'GET, POST, PUT,PATCH, DELETE, OPTIONS',
        //     'Content-Type': 'application/json; charset=utf-8',
        //      'Accept': ['application/json', 'text/plain', '*/*'],
        //     'Authorization': `Bearer ${this.auth.getTokken()}`,
        //     "Permissions-Policy": "camera=*,geolocation=*,microphone=*,autoplay=*,fullscreen=*,picture-in-picture=*,sync-xhr=*,encrypted-media=*,oversized-images=*",
        //     "Strict-Transport-Security": "max-age=31536000; includeSubdomains;preload",
        //     "X-Content-Type-Options": "nosniff",
        //     "X-Xss-Protection": "1; mode=block",
        //     "Content-Security-Policy": "default-src 'self';frame-src 'self' 'unsafe-inline' 'unsafe-eval' http://*/elm https://*/elm;script-src 'self' 'unsafe-inline' 'unsafe-eval'  http://*/elm https://*/elm;style-src 'self' 'unsafe-inline' 'unsafe-eval' http://*/elm https://*/elm"

        //   },
        // });
      // }
    }
    else // this section is for login request and this is one time only
    {
      req = req.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'Origin, Content-Type',
          'Access-Control-Allow-Methods': 'GET, POST, PUT,PATCH, DELETE, OPTIONS',
          'Content-Type': 'application/json; charset=utf-8',
          'Accept': ['application/json', 'text/plain', '*/*'],
          "Permissions-Policy": "camera=*,geolocation=*,microphone=*,autoplay=*,fullscreen=*,picture-in-picture=*,sync-xhr=*,encrypted-media=*,oversized-images=*",
          "Strict-Transport-Security": "max-age=31536000; includeSubdomains;preload",
          "X-Content-Type-Options": "nosniff",
          "X-Xss-Protection": "1; mode=block",
          "Content-Security-Policy": "default-src 'self';frame-src 'self' 'unsafe-inline' 'unsafe-eval' http://*/elm https://*/elm;script-src 'self' 'unsafe-inline' 'unsafe-eval'  http://*/elm https://*/elm;style-src 'self' 'unsafe-inline' 'unsafe-eval' http://*/elm https://*/elm"
        },
      });
    }

    return next.handle(req).pipe(
      catchError((error) => {
        return throwError(() => console.log(error));
      })
    );

  }
}
export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
